export default __webpack_public_path__ + "static/media/DocLand.fc7a0eb6.png";